import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import menu from '../menu';
// import MenuGroupItem from '../components/Menu/MenuGroupItem';
// import MenuItem from '../components/Menu/MenuItem';
import rolesApi from '../api/roles';
import userPermissionsApi from '../api/user-permissions';

function AppSidebar({ collapsed }) {
  // const [collapsed, setCollapsed] = useState(false);
  const isMount = useRef(false);
  const [menuDisplay, setMenuDisplay] = useState([]);
  const [openKeys, setOpenKeys] = useState([]);
  const lastOpenKeysRef = useRef([]);
  const authUser = useSelector((state) => state.auth.authUser);
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;

  const findParentKeys = useMemo(() => {
    const walk = (items, targetKey, parents = []) => {
      for (const item of items || []) {
        if (!item) continue;
        if (item.key === targetKey) return parents;
        if (item.children?.length) {
          const found = walk(item.children, targetKey, [...parents, item.key]);
          if (found) return found;
        }
      }
      return null;
    };

    return (items, targetKey) => walk(items, targetKey) || [];
  }, []);

  useEffect(() => {
    isMount.current = true;
    const fetchMenuData = async () => {
      try {
        if (isMount) {
          let menus = menu;
          if (
            authUser?.collaborator?.params ||
            authUser?.userOperator?.params
          ) {
            const attribute =
              JSON.parse(authUser?.collaborator?.params || '{}')?.attribute ||
              JSON.parse(authUser?.userOperator?.params || '{}')?.attribute;

            if (attribute) {
              if (!attribute.includes('bookings')) {
                menus = menus.map((menu) =>
                  menu.key === '/app/report'
                    ? {
                        ...menu,
                        children: menu.children?.filter(
                          (child) =>
                            !['/app/report/booking'].includes(child.key),
                        ),
                      }
                    : menu,
                );
              }
              if (
                !attribute?.includes('passenger_list') &&
                !attribute.includes('finance')
              ) {
                menus = menus.map((menu) =>
                  menu.key === '/app/report'
                    ? {
                        ...menu,
                        children: menu.children?.filter(
                          (child) => !['/app/report/trips'].includes(child.key),
                        ),
                      }
                    : menu,
                );
              }
              console.log('attribute', attribute);
              if (!attribute?.includes('finance')) {
                menus = menus
                  // Bước 1: filter bỏ luôn /app/revenue ở level 1
                  .filter((menu) => menu.key !== '/app/revenue')
                  // Bước 2: nếu là /app/report thì filter children
                  .map((menu) =>
                    menu.key === '/app/report'
                      ? {
                          ...menu,
                          children: menu.children?.filter(
                            (child) =>
                              ![
                                '/app/revenue',
                                '/app/report/sales',
                                attribute?.includes('passenger_list')
                                  ? '' // nếu có passenger_list thì không xoá trips
                                  : '/app/report/trips',
                              ].includes(child.key),
                          ),
                        }
                      : menu,
                  );
              }

              if (
                // !attribute.includes('routes') ||
                !attribute.includes('add_departure')
              ) {
                menus = menus.map((menu) =>
                  menu.key === '/app/settings'
                    ? {
                        ...menu,
                        children: menu.children?.filter(
                          (child) =>
                            !['/app/settings/depart'].includes(child.key),
                        ),
                      }
                    : menu,
                );
              }

              if (
                !attribute.includes('create_account') &&
                authUser?.userOperator
              ) {
                menus = menus.map((menu) =>
                  menu.key === '/app/settings'
                    ? {
                        ...menu,
                        children: menu.children?.filter(
                          (child) =>
                            !['/app/settings/user'].includes(child.key),
                        ),
                      }
                    : menu,
                );
              }

              if (
                !attribute.includes('create_account') &&
                !attribute.includes('routes')
              ) {
                menus = menus.filter((i) => !['/app/settings'].includes(i.key));
              }

              if (!attribute.includes('report')) {
                menus = menus.map((menu) =>
                  menu.key === '/app/report'
                    ? {
                        ...menu,
                        children: menu.children?.filter(
                          (child) =>
                            !['/app/report/booking_statistics'].includes(
                              child.key,
                            ),
                        ),
                      }
                    : menu,
                );
              }
            }
          }
          setMenuDisplay(menus);
        }
      } catch (error) {
        console.error('Error fetching menu data:', error);
      }
    };
    fetchMenuData();

    return () => {
      isMount.current = false;
    };
  }, [authUser]);

  const openAllKeys = useMemo(() => {
    return (menuDisplay || [])
      .filter((item) => item?.children)
      .map((item) => item.key);
  }, [menuDisplay]);

  // On page load (or whenever the menu structure changes), default to opening all
  // submenus when the sidebar is expanded.
  useEffect(() => {
    if (collapsed) return;
    if (!openAllKeys.length) return;
    setOpenKeys(openAllKeys);
    lastOpenKeysRef.current = openAllKeys;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed, openAllKeys]);

  useEffect(() => {
    if (collapsed) {
      lastOpenKeysRef.current = openKeys;
      setOpenKeys([]);
      return;
    }

    // When expanding, restore previous open keys; otherwise open the parent
    // chain for the current route.
    const restored = lastOpenKeysRef.current;
    if (restored?.length) {
      setOpenKeys(restored);
    } else {
      setOpenKeys(findParentKeys(menuDisplay, pathname));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapsed]);

  useEffect(() => {
    if (collapsed) return;
    // Keep the current route visible in the menu.
    setOpenKeys((prev) => {
      if (prev?.length) return prev;
      return findParentKeys(menuDisplay, pathname);
    });
  }, [collapsed, findParentKeys, menuDisplay, pathname]);

  // const onCollapse = (collapsed) => {
  //   setCollapsed(collapsed);
  // };

  const onClickMenu = (key) => {
    history.push(key);
  };

  const filterMenu = (menuItems, items) => {
    return menuItems
      .map((menuItem) => {
        // console.log('menuItem: ', menuItem);
        const hasChildren = menuItem.children && menuItem.children.length > 0;
        let filteredChildren = null;

        if (hasChildren) {
          filteredChildren = filterMenu(menuItem.children, items);
        }

        const hasMatchingChild =
          filteredChildren && filteredChildren.length > 0;
        const hasMatchingItem = items.some(
          (item) => item.menuitem.path === menuItem.key,
        );

        if (hasMatchingChild) {
          return { ...menuItem, children: filteredChildren };
        } else if (hasMatchingItem) {
          return menuItem;
        }

        return null;
      })
      .filter(Boolean);
  };

  // const renderMenuItems = (menuItems) => {
  //   return menuItems.map((menuItem) => {
  //     const hasChildren = menuItem.children && menuItem.children.length > 0;
  //     if (hasChildren) {
  //       return (
  //         <Menu.SubMenu key={menuItem.key} title={menuItem.label}>
  //           {renderMenuItems(menuItem.children)}
  //         </Menu.SubMenu>
  //       );
  //     } else {
  //       return (
  //         <Menu.Item key={menuItem.key} icon={menuItem.icon}>
  //           {menuItem.label}
  //         </Menu.Item>
  //       );
  //     }
  //   });
  // };
  return (
    <Menu
      theme="light"
      mode="inline"
      selectedKeys={[pathname]}
      openKeys={openKeys}
      inlineCollapsed={collapsed}
      style={{ borderRight: 0, backgroundColor: 'inherit' }}
      onOpenChange={(keys) => {
        setOpenKeys(keys);
        lastOpenKeysRef.current = keys;
      }}
      onClick={({ item, key, keyPath }) => onClickMenu(key)}
      items={menuDisplay}></Menu>
  );
}

export default withRouter(AppSidebar);
